import { UpdateCareer, UpdateCareerApiModel } from './updateCareer.model';

export function updateCareerAdapter(
  updateCareerResponse: UpdateCareerApiModel
): UpdateCareer {
  return updateCareerResponse.data;
}
